import * as yup from "yup";
import { ClientError } from "../error";
export class BaseValueObject {
    constructor(args) {
        const error = this.validator(args);
        if (error !== undefined) {
            throw new ClientError.InvalidValueObject(error);
        }
    }
    toJson() {
        return this.getValue();
    }
    validate(value, schemaBuilder) {
        const schema = schemaBuilder();
        const shape = yup.object().shape(schema);
        try {
            shape.validateSync(value);
            return undefined;
        }
        catch (e) {
            if (yup.ValidationError.isError(e)) {
                return e.message;
            }
            throw e;
        }
    }
}
export class SingleValueObject extends BaseValueObject {
    voType = "single";
}
export class MultipleValueObject extends BaseValueObject {
    voType = "multiple";
}
//# sourceMappingURL=base-value-object.js.map